import gql from "graphql-tag"

export const UPLOAD_THERMAL_IMAGE = gql`
    mutation UploadImages($params: UploadImagesInput!) {
        uploadImages(params: $params) {
            state
            endpoints
        }
    }
`